<template>
  <div id="line5">
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.buildData();
    window.onresize = (value) => {
      //每次改变窗口调用一次resize()
      this.myChart.resize();
    };
  },
  methods: {
    //生成柱状图数据
    buildData() {
      var columLabel = [
        "民意收集量",
        "问题处理数量",
      ];
      var colorList = [
        "#B6A2DE",
        "#F9FD5C"
      ];
      var columName = [];
       var postNumArr = [];
      var processedNumArr = [];
      var arrData = [];
      this.dataList.map((item) => {
        columName.push(item.town);
        postNumArr.push(item.postNum);
        processedNumArr.push(item.processedNum);
      });
      arrData.push(postNumArr);
      arrData.push(processedNumArr);


      var columnValue = new Array();
      for (var i = 0; i < columLabel.length; i++) {
        if (typeof columLabel[i] === "undefined") {
          break;
        }
        columnValue.push({
          name: columLabel[i],
          type: "bar",
          data: arrData[i],
          itemStyle: {
            normal: {
              color: colorList[i],
            },
          },
          barWidth : 20,//柱图宽度
        });
      }
      console.log(columnValue);

      this.init(columLabel, columName, columnValue);
    },
    // 生成图形
    init(columLabel, columName, columnValue) {
      this.myChart = echarts.init(document.getElementById("line5"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: columLabel,
          itemGap: 17,
          itemHeight: 12,
          textStyle: {
            color: "#ffffff",
            fontSize: 16,
          },
          x: "380",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            min: 0,
            type: "category",
            data: columName,
            boundaryGap: true, // x轴两边是否留白
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色
                fontSize: 16,
              },
            },
          },
        ],
        // 横向拖动
        dataZoom: [
          {
            type: "slider",
            show: true,
            startValue: 0,
            endValue: 5,
            height: "12",
            bottom: "3%",
            zoomLock: true,
            textStyle: {
              color: "#ffffff",
            },
          },
        ],
        yAxis: [
          {
            min: 0,
            max: function (val) {
              return val.max * 2;
            },
            name: "单位（个）",
            nameTextStyle: {
              color: "#ffffff",
              padding: [0, 0, 10, 0],
              fontSize: 15,
            },
            type: "value",
            // 坐标线
            axisLine: {
              show: true,
            },
            // 坐标刻度线
            axisTick: {
              show: true,
            },
            splitLine: { show: false }, //去除网格线
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色
               fontSize: 15,
              },
            },
          },
        ],
        series: columnValue,
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
#line5 {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt_echart/collection_num.vue